import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useCallback, useEffect, useState } from 'react';
import { Button, Flex, Input, notification } from 'antd';
import configuration from '@totem/utilities/configuration';
var inputStyle = {
  width: '400px'
};
var textStyle = {
  fontSize: '24px',
  fontWeight: 600,
  marginTop: '50px'
};
var RequestPasswordReset = function RequestPasswordReset() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSending = _useState2[0],
    setIsSending = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    inputEmail = _useState4[0],
    setInputEmail = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    notifyTitle = _useState6[0],
    setNotifyTitle = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    notifyDescription = _useState8[0],
    setNotifyDescription = _useState8[1];
  var _notification$useNoti = notification.useNotification(),
    _notification$useNoti2 = _slicedToArray(_notification$useNoti, 2),
    api = _notification$useNoti2[0],
    contextHolder = _notification$useNoti2[1];
  useEffect(function () {
    if (notifyTitle !== '') {
      api.info({
        message: notifyTitle,
        description: notifyDescription,
        placement: 'top'
      });
      setNotifyTitle('');
      setNotifyDescription('');
    }
  }, [notifyTitle, notifyDescription]);
  var sendPasswordResetRequest = useCallback(/*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(emailAddress) {
      var baseUrl, payload;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!isSending) {
              _context.next = 1;
              break;
            }
            return _context.abrupt("return");
          case 1:
            baseUrl = configuration.API_DOMAIN;
            payload = {
              email: emailAddress
            };
            setIsSending(true);
            fetch("".concat(baseUrl, "/ras/passwordReset"), {
              method: 'POST',
              headers: new Headers({
                'Content-Type': 'application/json'
              }),
              body: JSON.stringify(payload)
            }).then(function (res) {
              setIsSending(false);
              if (res.status < 400) {
                // Success
                setInputEmail('');
                setNotifyTitle('Success');
                setNotifyDescription('Request for password reset email has been successfully sent.');
              } else {
                // Failed
                setNotifyTitle('Error');
                setNotifyDescription('An error occurred requesting password reset email.');
              }
            });
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [isSending]);
  var handleClick = function handleClick() {
    sendPasswordResetRequest(inputEmail);
  };
  var handleChange = function handleChange(_ref2) {
    var value = _ref2.target.value;
    setInputEmail(value);
  };
  return /*#__PURE__*/React.createElement(Flex, {
    gap: "middle",
    align: "center",
    justify: "center",
    vertical: true
  }, /*#__PURE__*/React.createElement("div", {
    style: textStyle
  }, "Enter email address to request a password reset email."), /*#__PURE__*/React.createElement(Input, {
    style: inputStyle,
    value: inputEmail,
    onChange: handleChange
  }), /*#__PURE__*/React.createElement(Button, {
    title: "Submit",
    onClick: handleClick,
    type: "primary"
  }, "Submit"), contextHolder);
};
export default RequestPasswordReset;